export const getModalLang = (lang: string) => {
  switch (lang) {
    case "uk":
      return "ua"
    default:
      return lang
  }
}
